var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHammer16 = function SvgHammer16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.738 6.193-4.69 5.029a1.151 1.151 0 0 0 0 1.547l1.083 1.16a.972.972 0 0 0 1.443 0l4.688-5.028M6.738 6.193l.36-.387a1.151 1.151 0 0 0 0-1.547l-1.082-1.16.36-.388c1.196-1.281 3.134-1.281 4.33 0l3.245 3.482c.399.427.399 1.12 0 1.547L12.87 8.9a.972.972 0 0 1-1.442 0l-.361-.386a.972.972 0 0 0-1.443 0l-.36.387M6.737 6.193 9.262 8.9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgHammer16;